import useClipboard from "../hooks/use-clipboard/use-clipboard";
import OpticksButton from "../ui/OpticksButton/OpticksButton";
import CopyIcon from "../ui/OpticksIcons/CopyIcon";
import "./ChannelIntegrationTable.css";

interface Props {
  data: {
    category: string;
    option: string;
    value: string;
    valueOptions?: {
      allowCopy?: boolean;
      italics?: boolean;
    };
  }[];
}

const ChannelIntegrationTable = ({ data }: Props) => {
  const { copy } = useClipboard();

  return (
    <table className="integration-table">
      <tbody>
        {data.map((element, index) => {
          return (
            <tr key={index}>
              <td>
                <b>{element.category}</b>
              </td>
              <td>{element.option}</td>
              <td>
                {element.valueOptions?.italics ? (
                  <i>{element.value}</i>
                ) : (
                  element.value
                )}
                {element.valueOptions?.allowCopy !== false && (
                  <OpticksButton
                    icon={<CopyIcon className="icon-mid-blue-grey" />}
                    onClick={() =>
                      copy(
                        element.value,
                        `${element.category} "${element.value}" copied`
                      )
                    }
                  />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ChannelIntegrationTable;
